module.exports = __webpack_public_path__ + "static/media/circle-notch.0026c547.svg";